import api from './api';

//agristack
export const fetchFarmerByAadhar11 = (aadhar) => api.get(`/farmer/${aadhar}`);
export const fetchFarmerByAadhar = (aadhar) => api.post(`/farmer/json`, aadhar );
export const fetchUserWallet = () => api.get('/farmer/fetch-wallet');
export const fetchUsertransactions = () => api.get(`/farmer/transactions`);
export const createUserWallet = (wallet) => api.post(`/farmer/create-wallet`, wallet);
export const fetchPaidFarmerByTXId = (txId) => api.get(`/farmer/paid/${txId}`);


// Auth
export const signup = (data) => api.post('/auth/register', data);
export const registerWebUser  = (data) => api.post('/auth/web/register', data);

export const login = (data) => api.post('/auth/login', data);
export const sendOtp = (data) => api.post('auth/send-otp', data);
export const verifyOtp = (data) => api.post('auth/verify-otp', data);
export const resetPassword = (data) => api.post('auth/reset-password', data);

// payment
export const createPaymentSession = (data) => api.post('/api/payment/session', data);
//export const resetPassword = (data) => api.post('auth/reset-password', data);

export const getUserCreditSummary = () => api.get(`/farmer/user-credit-summary`);
export const getUserTransactionSummary = () => api.get(`/farmer/user-transaction-summary`);